module.exports = __webpack_public_path__ + "media/images/athletes/2470-d5bf0c739ff07a5b75c98f2b531e63f0.png";